import { gql } from '@apollo/client';

export const SEND_MESSAGE_TO_MODEL = gql`
  query SendMessageToModel($input: ISendMessageToModel) {
    sendMessageToModel(input: $input) {
      iaResponse
      from_message_id
      conversation_id
      message_id
    }
  }
`;
